.selected-ticket-footer .total-container {
  margin: 0 10px 10px;
  text-align: right;
}
.selected-ticket-footer .total-container .total {
  font-weight: bold;
}
.selected-ticket-footer .total-container .info {
  font-size: 12px;
  color: #404040;
}
.selected-ticket-footer button {
  min-width: 100%;
  width: 100%;
  margin-bottom: 10px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL2J1eXRpY2tldHMiLCJzb3VyY2VzIjpbInNlbGVjdGVkLXRpY2tldC1mb290ZXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDSTtFQUNJO0VBQ0E7O0FBRUE7RUFDSTs7QUFHSjtFQUNJO0VBQ0E7O0FBSVI7RUFDSTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuc2VsZWN0ZWQtdGlja2V0LWZvb3RlciB7XG4gICAgLnRvdGFsLWNvbnRhaW5lcntcbiAgICAgICAgbWFyZ2luOiAwIDEwcHggMTBweDtcbiAgICAgICAgdGV4dC1hbGlnbjogcmlnaHQ7XG5cbiAgICAgICAgLnRvdGFsIHtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgICAgICB9XG5cbiAgICAgICAgLmluZm8ge1xuICAgICAgICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgICAgICAgICAgY29sb3I6ICM0MDQwNDA7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBidXR0b24ge1xuICAgICAgICBtaW4td2lkdGg6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICAgIH1cbn1cbiJdfQ== */